import {
  CATEGORIES,
  LABELS,
  ACTIONS,
  EVENTS
} from 'modules/app/services/ga/constants';
import GtagService from 'modules/app/services/ga/GtagService';

export const sendConfirmEvent = () => {
  GtagService.sendEvent({
    event: EVENTS.INTERACTION,
    category: CATEGORIES.SCHEDULE,
    action: ACTIONS.CLICK,
    where: ACTIONS.SCHEDULE.MODAL_RESEND_ACCESS,
    label: LABELS.SEND_NOW
  });
};

export const sendCancelEvent = () => {
  GtagService.sendEvent({
    event: EVENTS.INTERACTION,
    category: CATEGORIES.SCHEDULE,
    action: ACTIONS.CLICK,
    where: ACTIONS.SCHEDULE.MODAL_RESEND_ACCESS,
    label: LABELS.SEND_LATER
  });
};
